import router from "@/router";
import { AxiosError } from "axios";
import { ref } from "vue";
import { useDeviceStore } from "@/stores/device.store";
import { useI18n } from "vue-i18n";
import { toast } from "vue3-toastify";

export const useRegisterDevice = () => {
    const startCode = ref("");
    const isCurrentlyRegistering = ref(false);
    const deviceStore = useDeviceStore();
    const { t } = useI18n({ useScope: "global" });
    const startCodeLength = 8;

    const registerDevice = async () => {
        if (isCurrentlyRegistering.value) {
            toast(t("timeRecordingError.alreadyRegistering"), { type: "info" });
            return;
        }

        isCurrentlyRegistering.value = true;

        if (startCode.value.length !== startCodeLength) {
            toast(t("timeRecordingError.enterAStartCode", { length: startCodeLength }), {
                type: "error",
            });
            isCurrentlyRegistering.value = false;
            return;
        }

        try {
            await deviceStore.register(startCode.value);
            await router.replace({ name: "Root" });
            return true;
        } catch (error) {
            const axiosError = error as AxiosError;
            let message = "";
            const detailedErrors = (axiosError?.response?.data as any)?.errors;
            if (detailedErrors && detailedErrors.length > 0) {
                message = detailedErrors[0].message;
            } else {
                message = (axiosError?.response as any)?.message ?? axiosError?.message ?? error;
            }
            toast(t("somethingWentWrong") + "\n\n" + t("registerDevice.registerDeviceFailed") + "\n\n" + message, {
                type: "error",
            });
            startCode.value = "";

            return false;
        } finally {
            isCurrentlyRegistering.value = false;
        }
    };

    return {
        startCode,
        isCurrentlyRegistering,
        registerDevice,
        startCodeLength,
    };
};
